import React from 'react';

import { AuthProvider } from './Auth';
import { ToastProvider } from './Toast';

import { ModalProvider } from './Modal';
import { SearchProvider } from './Search';
import { ScrollProvider } from './Scroll';
 
import { PagesProvider } from './Pages';
import { InteractionProvider } from './Interactions';
import { LanguageProvider } from './Language';
import { ConfigurationProvider } from './Configuration';
import { LoadingProvider } from './LoadingHook';
 
const AppProvider: React.FC = ({ children }) => {
  return (<LoadingProvider>
    <AuthProvider>
      <LanguageProvider>
        <ConfigurationProvider>
          <PagesProvider>
     

              <InteractionProvider>
                <ToastProvider>
                  <SearchProvider>
                    <ModalProvider>

                      <ScrollProvider>{children}</ScrollProvider>

                    </ModalProvider>
                  </SearchProvider>
                </ToastProvider>
              </InteractionProvider>

          
          </PagesProvider>
        </ConfigurationProvider>
      </LanguageProvider>

    </AuthProvider>
  </LoadingProvider>
  );
};

export default AppProvider;
